import { BillBalanceModifierReference } from '@features/bills/enums/BillBalanceModifierReference'

export const creditNoteBalanceModifierReferenceToTKey: Record<BillBalanceModifierReference, string> = {
  [BillBalanceModifierReference.BankPayment]: 'bills.view.payment_pane.modifier.bank_payment',
  [BillBalanceModifierReference.Bill]: 'bills.view.payment_pane.modifier.bill',
  [BillBalanceModifierReference.ContactBalancePayment]: 'bills.view.payment_pane.modifier.contact_balance_payment',
  [BillBalanceModifierReference.DaybookTransaction]: 'bills.view.payment_pane.modifier.daybook_transaction',
}
